import { Controller } from "@hotwired/stimulus"
import { debounce } from "../utils"

export default class extends Controller {
  static values = { url: String }

  update = debounce(async (event) => {
    const invoiceCount = event.target.value

    const url = new URL(this.urlValue, window.location.origin)
    url.searchParams.set("generate_lease_invoices[invoice_count]", invoiceCount)

    const response = await fetch(url, {
      headers: { Accept: "text/vnd.turbo-stream.html" },
    })

    if (response.ok) {
      Turbo.renderStreamMessage(await response.text())
    }
  }, 200)
}
